export { DocumentAdd as default } from './DocumentAdd';
